<template>
  <div>
    <div class="text-subtitle-2 pa-1 blue--text blue lighten-5 mb-2">
      使用する画像ファイルをアップロードしてください。保存ボタンを押すまで確定しません。
    </div>
    <v-card tile elevation="0" class="item-card">
      <v-container fluid>
        <v-row justify="start">
          <v-col cols="6" sm="3">
            <general-button btn_type="info" btn_block @click-event="onSubmit"
              ><template v-slot:icon
                ><v-icon left>mdi-content-save</v-icon></template
              >保存</general-button
            >
          </v-col>
        </v-row>
      </v-container>

      <ValidationObserver ref="observer">
        <v-container fluid>
          <div class="pa-2 indigo mb-4">
            <h2 class="font-weight-bold white--text mb-0 big">
              サイト基本設定
            </h2>
          </div>

          <v-row>
            <v-col cols="12">
              <h3>ホームページの店舗名</h3>
              <div class="mt-2 mb-2 pa-2">
                <div class="mb-2">
                  姉妹店オプション使用時、店舗名を変更したい時に入力してください。省略時、ヤトイテに登録してある店舗名が使用されます。
                </div>
                <v-text-field
                  v-model="category_items.site_shop_name.detail"
                  :name="category_items.site_shop_name.category_code"
                  label="店舗名"
                  :success="true"
                  :placeholder="category_items.site_shop_name.placeholder"
                  outlined
                  hide-details
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h3>ホームページのタイトル</h3>
              <div class="mt-2 mb-2 pa-2">
                <div class="mb-2">
                  タイトルを入力してください。省略時、店舗名がタイトルとして設定されます。
                </div>
                <v-text-field
                  v-model="category_items.site_title.detail"
                  :name="category_items.site_title.category_code"
                  label="タイトル"
                  :success="true"
                  :placeholder="category_items.site_title.placeholder"
                  outlined
                  hide-details
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h3>ホームページの説明文</h3>
              <div class="mt-2 mb-2 pa-2">
                <div class="mb-2">
                  説明文を入力してください。metaタグのdescriptionに設定されます。
                </div>
                <v-textarea
                  v-model="category_items.description.detail"
                  :name="category_items.description.category_code"
                  label="サイト説明文（ディスクリプション）"
                  :success="true"
                  :placeholder="category_items.description.placeholder"
                  outlined
                  hide-details
                  rows="3"
                  auto-grow
                ></v-textarea>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <h3>年齢認証ページを表示する</h3>
              <div class="mt-2 mb-2 pa-2">
                <div class="mb-2">
                  年齢認証ページを表示する場合は、ONにしてください。
                </div>
                <v-switch
                  v-model="category_items.age_verifi.detail"
                  :label="category_items.age_verifi.detail ? '表示' : '非表示'"
                  class="pa-2 ml-auto"
                ></v-switch>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <h3>セラピスト表記を変更する</h3>
              <div class="mt-2 mb-2 pa-2">
                <div class="mb-2">
                  ホームページ上の「セラピスト」という表記を任意の表記に変更する場合は、ONにして表記を入力してください。
                </div>
                <v-switch
                  v-model="category_items.therapist_rename.detail"
                  :label="category_items.therapist_rename.detail ? 'ON' : 'OFF'"
                  class="pa-2 ml-auto"
                ></v-switch>
                <ValidationProvider
                  v-slot="{ errors, valid }"
                  name="日本語表記"
                  :rules="`${
                    category_items.therapist_rename.detail ? 'required|' : ''
                  }max:6`"
                >
                  <v-text-field
                    v-model="category_items.therapist_name_ja.detail"
                    :name="category_items.therapist_name_ja.category_code"
                    label="日本語表記"
                    :error-messages="errors"
                    :success="valid"
                    :disabled="!category_items.therapist_rename.detail"
                    :placeholder="category_items.therapist_name_ja.placeholder"
                    outlined
                    counter="6"
                  ></v-text-field>
                </ValidationProvider>
                <ValidationProvider
                  v-slot="{ errors, valid }"
                  name="英語表記"
                  :rules="`${
                    category_items.therapist_rename.detail ? 'required|' : ''
                  }custom_alpha_num|max:10`"
                >
                  <v-text-field
                    v-model="category_items.therapist_name_en.detail"
                    :name="category_items.therapist_name_en.category_code"
                    label="英語表記"
                    :error-messages="errors"
                    :success="valid"
                    :disabled="!category_items.therapist_rename.detail"
                    :placeholder="category_items.therapist_name_en.placeholder"
                    outlined
                    counter="10"
                  ></v-text-field>
                </ValidationProvider>
              </div>
            </v-col>
          </v-row>

          <div class="pa-2 indigo mt-8 mb-4">
            <h2 class="font-weight-bold white--text mb-0 big">
              外部媒体の設定
            </h2>
          </div>

          <v-row>
            <v-col cols="12">
              <h3>求人ページ</h3>
              <div class="mt-2 mb-2 pa-2">
                <div class="mb-2">
                  他媒体の求人情報やLINEに誘導したい場合はURLを入力してください。
                </div>
                <ValidationProvider
                  v-slot="{ errors, valid }"
                  name="求人ページURL"
                  rules="url|max:255"
                >
                  <v-text-field
                    v-model="category_items.req_page_url.detail"
                    :name="category_items.req_page_url.category_code"
                    label="求人ページURL"
                    :error-messages="errors"
                    :success="valid"
                    :placeholder="category_items.req_page_url.placeholder"
                    hint="任意入力です。求人ページの正確なURLを入力してください"
                    persistent-hint
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <h3>予約ページ</h3>
              <div class="mt-2 mb-2 pa-2">
                <div class="mb-2">
                  他媒体の予約ページやLINEに誘導する場合はURLを入力してください。
                </div>
                <ValidationProvider
                  v-slot="{ errors, valid }"
                  name="バナー1のリンク先URL"
                  rules="url|max:255"
                >
                  <v-text-field
                    v-model="category_items.booking_url.detail"
                    :name="category_items.booking_url.category_code"
                    label="予約ページURL"
                    :error-messages="errors"
                    :success="valid"
                    :placeholder="category_items.booking_url.placeholder"
                    hint="任意入力です。予約ページの正確なURLを入力してください"
                    persistent-hint
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </div>
            </v-col>
          </v-row>

          <div class="pa-2 indigo mt-8 mb-4">
            <h2 class="font-weight-bold white--text mb-0 big">
              サイト全体のデザイン
            </h2>
          </div>

          <v-row>
            <v-col cols="12">
              <h3>テーマコード</h3>
              <div class="mt-2 mb-2 pa-2">
                <div class="mb-2">
                  テーマコードは、運営にて管理しております。指定されたコードを入力してください。
                </div>
                <v-text-field
                  v-model="category_items.theme_name.detail"
                  :name="category_items.theme_name.category_code"
                  label="テーマコード"
                  :success="true"
                  :placeholder="category_items.theme_name.placeholder"
                  hint="任意入力です。正確なテーマコードを入力してください"
                  persistent-hint
                  outlined
                ></v-text-field>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <h3>ロゴ画像</h3>
              <div class="mt-2 mb-2 pa-2">
                <div>
                  ロゴ画像を設定します。※横400px:縦100px(アスペクト比4:1)以内の画像サイズを推奨。
                </div>
                <image-uploader-component
                  :ref="category_items.logo_image.ref"
                  :width="category_items.logo_image.width"
                  :height="category_items.logo_image.height"
                  :image_path="category_items.logo_image.detail"
                  :contain="true"
                ></image-uploader-component>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h3>アイコン画像</h3>
              <div class="mt-2 mb-2 pa-2">
                <div>
                  サイトのアイコン画像を設定します。※横512px:縦512px(アスペクト比1:1)程度の画像サイズを推奨。
                </div>
                <image-uploader-component
                  :ref="category_items.site_icon.ref"
                  :width="category_items.site_icon.width"
                  :height="category_items.site_icon.height"
                  :image_path="category_items.site_icon.detail"
                  :contain="true"
                ></image-uploader-component>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h3>画像なしセラピスト用の画像</h3>
              <div class="mt-2 mb-2 pa-2">
                <div>
                  セラピスト画像が無い時に表示する画像を設定します。※横400px:縦600px(アスペクト比2:3)程度の画像サイズを推奨。
                </div>
                <image-uploader-component
                  :ref="category_items.no_image.ref"
                  :width="category_items.no_image.width"
                  :height="category_items.no_image.height"
                  :image_path="category_items.no_image.detail"
                  :contain="true"
                ></image-uploader-component>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h3>背景用の画像</h3>
              <div class="mt-2 mb-2 pa-2">
                <v-row>
                  <v-col cols="12" sm="6">
                    <span>メインコンテンツの背景画像</span>
                    <image-uploader-component
                      :ref="category_items.bg_image_a.ref"
                      :width="category_items.bg_image_a.width"
                      :height="category_items.bg_image_a.height"
                      :image_path="category_items.bg_image_a.detail"
                      :contain="true"
                    ></image-uploader-component>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <span>左右の余白部分の背景画像</span>
                    <image-uploader-component
                      :ref="category_items.bg_image_b.ref"
                      :width="category_items.bg_image_b.width"
                      :height="category_items.bg_image_b.height"
                      :image_path="category_items.bg_image_b.detail"
                      :contain="true"
                    ></image-uploader-component>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h3>フッター埋め込みHTML</h3>
              <div class="mt-2 mb-2">
                <v-btn
                  text
                  color="primary"
                  class="font-weight-bold pa-1 d-inline"
                  @click="onHtmlClear(2)"
                  >HTMLをクリア</v-btn
                >
                <p class="mini text-red">
                  ※GoogleMapやバナー等のHTMLを使用する際は「ソース」をクリックしてから、HTMLを貼り付け、再度「ソース」をクリックして元の画面に戻ってから保存してください。
                </p>
              </div>
              <v-card tile elevation="0" class="mb-6">
                <div class="ma-3">
                  <ckeditor-component
                    :ref="category_items.footer_html.ref"
                    :data="category_items.footer_html.detail"
                  ></ckeditor-component>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <div class="pa-2 indigo mt-8 mb-4">
            <h2 class="font-weight-bold white--text mb-0 big">
              トップページのデザイン
            </h2>
          </div>

          <v-row>
            <v-col cols="12">
              <h3>トップ画像</h3>
              <div class="mt-2 mb-2 pa-2">
                <div>トップページのメイン画像を設定します。</div>
                <image-uploader-component
                  :ref="category_items.top_image.ref"
                  :width="category_items.top_image.width"
                  :height="category_items.top_image.height"
                  :image_path="category_items.top_image.detail"
                  :contain="true"
                ></image-uploader-component>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h3>バナー画像（最大3枚まで設定可）</h3>
              <div class="mt-2 mb-2 pa-2">
                <div class="mb-2">
                  トップページに表示するバナー用の画像を設定します。※フリーサイズ(縦長、横長どちらでも可)
                </div>
                <h3 class="mb-2">バナー画像 1</h3>
                <ValidationProvider
                  v-slot="{ errors, valid }"
                  name="バナー1のリンク先URL"
                  rules="url|max:255"
                >
                  <v-text-field
                    v-model="category_items.banner1.name"
                    :name="category_items.banner1.category_code + '_url'"
                    label="バナー1のリンク先URL"
                    :error-messages="errors"
                    :success="valid"
                    outlined
                    placeholder="https://..."
                    hint="任意入力です。リンク先の正確なURLを入力してください。リンク先は新しいタブで開きます。"
                    persistent-hint
                    class="mb-2"
                  ></v-text-field>
                </ValidationProvider>

                <image-uploader-component
                  :ref="category_items.banner1.ref"
                  :width="category_items.banner1.width"
                  :height="category_items.banner1.height"
                  :image_path="category_items.banner1.detail"
                  :contain="true"
                ></image-uploader-component>
              </div>
              <div class="mt-2 mb-2 pa-2">
                <h3 class="mb-2">バナー画像 2</h3>
                <ValidationProvider
                  v-slot="{ errors, valid }"
                  name="バナー2のリンク先URL"
                  rules="url|max:255"
                >
                  <v-text-field
                    v-model="category_items.banner2.name"
                    :name="category_items.banner2.category_code + '_url'"
                    label="バナー2のリンク先URL"
                    :error-messages="errors"
                    :success="valid"
                    outlined
                    placeholder="https://..."
                    hint="任意入力です。リンク先の正確なURLを入力してください。リンク先は新しいタブで開きます。"
                    persistent-hint
                    class="mb-2"
                  ></v-text-field>
                </ValidationProvider>
                <image-uploader-component
                  :ref="category_items.banner2.ref"
                  :width="category_items.banner2.width"
                  :height="category_items.banner2.height"
                  :image_path="category_items.banner2.detail"
                  :contain="true"
                ></image-uploader-component>
              </div>
              <div class="mt-2 mb-2 pa-2">
                <h3 class="mb-2">バナー画像 3</h3>
                <ValidationProvider
                  v-slot="{ errors, valid }"
                  name="バナー3のリンク先URL"
                  rules="url|max:255"
                >
                  <v-text-field
                    v-model="category_items.banner3.name"
                    :name="category_items.banner3.category_code + '_url'"
                    label="バナー3のリンク先URL"
                    :error-messages="errors"
                    :success="valid"
                    outlined
                    placeholder="https://..."
                    hint="任意入力です。リンク先の正確なURLを入力してください。リンク先は新しいタブで開きます。"
                    persistent-hint
                    class="mb-2"
                  ></v-text-field>
                </ValidationProvider>
                <image-uploader-component
                  :ref="category_items.banner3.ref"
                  :width="category_items.banner3.width"
                  :height="category_items.banner3.height"
                  :image_path="category_items.banner3.detail"
                  :contain="true"
                ></image-uploader-component>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h3>
                カスタムリンクバナー（最大{{
                  setting.hp_link_custom_banner_max
                }}個まで設定可）
              </h3>
              <div class="mt-2 mb-2 pa-2">
                <div class="mb-2">
                  トップページに表示するバナーを追加します。※フリーサイズ(縦長、横長どちらでも可)<br />
                  表示する位置は、ページ下部の「コンテンツ配置」で設定してください。（現在
                  {{ custom_banners.length }} /
                  {{ setting.hp_link_custom_banner_max }} 個）
                </div>
                <v-expansion-panels
                  v-model="custom_banner_panels"
                  multiple
                  flat
                  class="mb-4"
                >
                  <v-expansion-panel
                    v-for="(banner, b_index) in custom_banners"
                    :key="banner.key"
                    class="mb-2"
                    style="
                      border: solid 1px #ddd !important;
                      border-radius: 10px;
                    "
                  >
                    <v-expansion-panel-header>
                      <div class="d-flex align-center">
                        <v-img
                          v-if="banner.detail"
                          :src="setting.cdn + banner.detail"
                          width="64"
                          height="32"
                          contain
                          class="flex-grow-0 mr-3"
                        ></v-img>
                        <div>
                          <div class="font-weight-bold">
                            カスタムリンクバナー {{ b_index + 1 }}
                          </div>
                          <div class="text-caption grey--text">
                            {{ banner.name || "リンクなし" }}・{{
                              banner.target === "1" ? "新しいタブ" : "同じタブ"
                            }}
                          </div>
                        </div>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content eager>
                      <ValidationProvider
                        v-slot="{ errors, valid }"
                        :name="
                          'カスタムリンクバナー' +
                          (b_index + 1) +
                          'のリンク先URL'
                        "
                        rules="url|max:255"
                      >
                        <v-text-field
                          v-model="banner.name"
                          :name="'custom_banner' + (b_index + 1) + '_url'"
                          label="リンク先URL"
                          :error-messages="errors"
                          :success="valid"
                          outlined
                          placeholder="https://..."
                          hint="任意入力です。リンク先の正確なURLを入力してください。"
                          persistent-hint
                          class="mb-2"
                        ></v-text-field>
                      </ValidationProvider>
                      <div class="mt-2">リンク先を開くタブ</div>
                      <v-radio-group
                        class="mt-0"
                        v-model="banner.target"
                        mandatory
                        row
                      >
                        <v-radio label="同じタブ" value="0"></v-radio>
                        <v-radio label="新しいタブ" value="1"></v-radio>
                      </v-radio-group>
                      <div class="mb-2">バナー画像（必須）</div>
                      <image-uploader-component
                        :ref="custom_banner_ref_prefix + banner.key"
                        :width="600"
                        :height="300"
                        :image_path="banner.detail"
                        :contain="true"
                      ></image-uploader-component>
                      <v-btn
                        text
                        color="error"
                        class="font-weight-bold mt-4 pa-1"
                        @click="removeCustomBanner(b_index)"
                        ><v-icon left>mdi-delete</v-icon
                        >このカスタムリンクバナーを削除</v-btn
                      >
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <general-button
                      btn_type="info"
                      btn_block
                      @click-event="addCustomBanner"
                      :btn_disabled="
                        custom_banners.length >=
                        setting.hp_link_custom_banner_max
                      "
                      ><template v-slot:icon
                        ><v-icon left>mdi-plus</v-icon></template
                      >カスタムリンクバナーを追加</general-button
                    >
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h3>トップページ埋め込みHTML</h3>
              <div class="mt-2 mb-2">
                <v-btn
                  text
                  color="primary"
                  class="font-weight-bold pa-1 d-inline"
                  @click="onHtmlClear(1)"
                  >HTMLをクリア</v-btn
                >
                <p class="mini text-red">
                  ※GoogleMapやバナー等のHTMLを使用する際は「ソース」をクリックしてから、HTMLを貼り付け、再度「ソース」をクリックして元の画面に戻ってから保存してください。
                </p>
              </div>
              <v-card tile elevation="0" class="mb-6">
                <div class="ma-3">
                  <ckeditor-component
                    :ref="category_items.top_html.ref"
                    :data="category_items.top_html.detail"
                  ></ckeditor-component>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h3>コンテンツ配置</h3>
              <div class="mt-2 mb-2 pa-2">
                <div class="mb-2">
                  コンテンツの配置順を設定。ドラッグして順番を入れ替えます。表示したくないコンテンツはスイッチを非表示にしてください。
                </div>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <draggable
                      v-model="category_items.top_order.drag_data"
                      v-bind="dragOptions"
                      handle=".hundle_card"
                      :force-fallback="true"
                      class="pr-4"
                    >
                      <div
                        v-for="content in category_items.top_order.drag_data"
                        :key="content.code"
                        class="hundle_card d-flex align-center grey lighten-5 px-2 mb-4"
                        style="
                          border-radius: 10px;
                          border: solid 1px #ddd !important;
                          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
                          cursor: move;
                        "
                      >
                        <v-icon>mdi-reorder-horizontal</v-icon>
                        <div class="pa-2 font-bold" style="user-select: none">
                          {{ content.name }}
                        </div>
                        <v-switch
                          v-model="content.show"
                          :label="content.show ? '表示' : '非表示'"
                          class="pa-2 ml-auto"
                        ></v-switch>
                      </div>
                    </draggable>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>

          <div class="pa-2 indigo mt-8 mb-4">
            <h2 class="font-weight-bold white--text mb-0 big">
              Googleアナリティクス関連
            </h2>
          </div>

          <v-row>
            <v-col cols="12" sm="6" md="4">
              <h3>Googleアナリティクス GA4 ID</h3>
              <div class="mt-2 mb-2 pa-2">
                <div class="mb-2">
                  計測をご希望の際はGA4の測定IDを設定してください。
                </div>
                <ValidationProvider
                  v-slot="{ errors, valid }"
                  name="Googleアナリティクス"
                  rules="gtag_id"
                >
                  <v-text-field
                    v-model="category_items.gtag_id.detail"
                    :name="category_items.gtag_id.category_code"
                    label="Googleアナリティクス"
                    :error-messages="errors"
                    :success="valid"
                    :placeholder="category_items.gtag_id.placeholder"
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h3>Googleアナリティクス所有権証明のコード</h3>
              <div class="mt-2 mb-2 pa-2">
                <div class="mb-2">
                  Googleアナリティクスの所有権を証明するためのコードをmetaタグに設定します。必要に応じて設定してください。
                </div>
                <ValidationProvider
                  v-slot="{ errors, valid }"
                  name="所有権証明のコード"
                  rules="ga_valid_code"
                >
                  <v-text-field
                    v-model="category_items.ga_valid_code.detail"
                    :name="category_items.ga_valid_code.category_code"
                    label="所有権証明のコード"
                    :error-messages="errors"
                    :success="valid"
                    :placeholder="category_items.ga_valid_code.placeholder"
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </ValidationObserver>

      <v-container fluid>
        <v-row justify="start">
          <v-col cols="6" sm="3">
            <general-button btn_type="info" btn_block @click-event="onSubmit"
              ><template v-slot:icon
                ><v-icon left>mdi-content-save</v-icon></template
              >保存</general-button
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import {
  ref,
  set,
  reactive,
  toRefs,
  defineComponent,
  watch,
  onMounted,
  nextTick,
} from "@vue/composition-api";
import store from "@/store/index.js";
import { repositoryFactory } from "@/repository/repositoryFactory";
import setting from "@/common/setting.js";
import draggable from "vuedraggable";
import imageUploaderComponent from "./imageUploader.vue";
import retryRequest from "@/common/retryRequest";

export default defineComponent({
  components: {
    imageUploaderComponent,
    draggable,
  },
  props: ["shop_site_id"],
  setup(props, ctx) {
    const HpListDetailRepository = repositoryFactory.get("hpListDetails");

    const refSiteShopName = ref(null);
    const refSiteTitle = ref(null);
    const refDescription = ref(null);
    const refBookingUrl = ref(null);
    const refIUBgImageA = ref(null);
    const refIUBgImageB = ref(null);
    const refIUTopImage = ref(null);
    const refIULogoImage = ref(null);
    const refIUSiteIcon = ref(null);
    const refIUBanner1 = ref(null);
    const refIUBanner2 = ref(null);
    const refIUBanner3 = ref(null);
    const refIUNoImage = ref(null);
    const refCkeditorTopHtml = ref(null);
    const refCkeditorFooterHtml = ref(null);
    const refGtagId = ref(null);
    const refGaValidCode = ref(null);

    const data_id = 1; // サイト設定 1固定

    // カスタムリンクバナー（category_num = バナー番号 1〜）
    const custom_banner_code = "custom_banner"; // name: リンク先URL, detail: 格納先PATH
    const custom_banner_target_code = "custom_banner_target"; // detail: "1"=新しいタブ / "0"=同じタブ
    const custom_banner_order_prefix = "custom_banner_"; // コンテンツ配置のコード（custom_banner_{番号}）
    const custom_banner_ref_prefix = "refIUCustomBanner";
    let custom_banner_key = 0; // v-for / ref 用の一意キー

    const state = reactive({
      // カスタムリンクバナー { key, name, detail, target }
      custom_banners: [],
      // 開いているカスタムリンクバナーのパネル
      custom_banner_panels: [],
      // 入力項目カテゴリごとのデータ構造体
      category_items: {
        site_shop_name: {
          type: "text",
          ref: "refSiteShopName",
          category_num: 0, // 0固定
          category_code: "site_shop_name",
          name: "",
          detail: "",
          placeholder: "例）ヤトイテエステ",
        },
        site_title: {
          type: "text",
          ref: "refSiteTitle",
          category_num: 0, // 0固定
          category_code: "site_title",
          name: "",
          detail: "",
          placeholder: "例）◯◯県◯◯市のメンズエステ ヤトイテエステ",
        },
        description: {
          type: "textarea",
          ref: "refDescription",
          category_num: 0, // 0固定
          category_code: "description",
          name: "",
          detail: "",
          placeholder:
            "例）当店は◯◯県◯◯市にあるメンズエステです。完全個室のプライベート空間で、厳選されたセラピストが心を込めて施術いたします。",
        },
        age_verifi: {
          type: "switch",
          ref: "refAgeVerifi",
          category_num: 0, // 0固定
          category_code: "age_verifi",
          name: "",
          detail: false,
          placeholder: "",
        },
        therapist_rename: {
          type: "switch",
          ref: "refTherapistRename",
          category_num: 0, // 0固定
          category_code: "therapist_rename",
          name: "",
          detail: false, // デフォルトOFF（レコード無しでも維持）
          placeholder: "",
        },
        therapist_name_ja: {
          type: "text",
          ref: "refTherapistNameJa",
          category_num: 0, // 0固定
          category_code: "therapist_name_ja",
          name: "",
          detail: "",
          placeholder: "例）キャスト",
        },
        therapist_name_en: {
          type: "text",
          ref: "refTherapistNameEn",
          category_num: 0, // 0固定
          category_code: "therapist_name_en",
          name: "",
          detail: "",
          placeholder: "例）Cast",
        },
        theme_name: {
          type: "text",
          ref: "refThemeName",
          category_num: 0, // 0固定
          category_code: "theme_name",
          name: "",
          detail: "",
          placeholder: "",
        },
        booking_url: {
          type: "text",
          ref: "refBookingUrl",
          category_num: 0, // 0固定
          category_code: "booking_url",
          name: "",
          detail: "",
          placeholder: "https://...",
        },
        req_page_url: {
          type: "text",
          ref: "refReqPageUrl",
          category_num: 0, // 0固定
          category_code: "req_page_url",
          name: "",
          detail: "",
          placeholder: "https://...",
        },
        top_image: {
          type: "image",
          ref: "refIUTopImage",
          category_num: 0, // 0固定
          category_code: "top_image",
          name: "",
          detail: "",
          component: imageUploaderComponent,
          width: 500,
          height: 750,
        },
        bg_image_a: {
          type: "image",
          ref: "refIUBgImageA",
          category_num: 0, // 0固定
          category_code: "bg_image_a",
          name: "",
          detail: "",
          component: imageUploaderComponent,
          width: 400,
          height: 400,
        },
        bg_image_b: {
          type: "image",
          ref: "refIUBgImageB",
          category_num: 0, // 0固定
          category_code: "bg_image_b",
          name: "",
          detail: "",
          component: imageUploaderComponent,
          width: 400,
          height: 400,
        },
        logo_image: {
          type: "image",
          ref: "refIULogoImage",
          category_num: 0, // 0固定
          category_code: "logo_image",
          name: "",
          detail: "",
          component: imageUploaderComponent,
          width: 400,
          height: 100,
        },
        site_icon: {
          type: "image",
          ref: "refIUSiteIcon",
          category_num: 0, // 0固定
          category_code: "site_icon",
          name: "",
          detail: "",
          component: imageUploaderComponent,
          width: 200,
          height: 200,
        },
        banner1: {
          type: "image",
          ref: "refIUBanner1",
          category_num: 0, // 0固定
          category_code: "banner1",
          name: "",
          detail: "",
          component: imageUploaderComponent,
          width: 600,
          height: 300,
        },
        banner2: {
          type: "image",
          ref: "refIUBanner2",
          category_num: 0, // 0固定
          category_code: "banner2",
          name: "",
          detail: "",
          component: imageUploaderComponent,
          width: 600,
          height: 300,
        },
        banner3: {
          type: "image",
          ref: "refIUBanner3",
          category_num: 0, // 0固定
          category_code: "banner3",
          name: "",
          detail: "",
          component: imageUploaderComponent,
          width: 600,
          height: 300,
        },
        no_image: {
          type: "image",
          ref: "refIUNoImage",
          category_num: 0, // 0固定
          category_code: "no_image",
          name: "",
          detail: "",
          component: imageUploaderComponent,
          width: 300,
          height: 450,
        },
        top_html: {
          type: "html",
          ref: "refCkeditorTopHtml",
          category_num: 0, // 0固定
          category_code: "top_html",
          name: "",
          detail: "",
        },
        footer_html: {
          type: "html",
          ref: "refCkeditorFooterHtml",
          category_num: 0, // 0固定
          category_code: "footer_html",
          name: "",
          detail: "",
        },
        gtag_id: {
          type: "text",
          ref: "refGtagId",
          category_num: 0, // 0固定
          category_code: "gtag_id",
          name: "",
          detail: "",
          placeholder: "例）G-XXXXXXXXXX",
        },
        ga_valid_code: {
          type: "text",
          ref: "refGaValidCode",
          category_num: 0, // 0固定
          category_code: "ga_valid_code",
          name: "",
          detail: "",
          placeholder: "例）XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX",
        },
        top_order: {
          type: "order",
          ref: "",
          category_num: 0, // 0固定
          category_code: "top_order",
          name: "",
          detail: "",
          placeholder: "",
          drag_data: setting.hp_link_top_content,
        },
      },
    });

    // コンテンツ配置のコードからカスタムリンクバナーの番号を取得（カスタムリンクバナー以外は0）
    const getCustomBannerNum = (code) => {
      if (!code || !code.startsWith(custom_banner_order_prefix)) return 0;
      return Number(code.slice(custom_banner_order_prefix.length)) || 0;
    };

    // コンテンツ配置に入れるカスタムリンクバナーの項目を生成
    const createCustomBannerOrder = (num, show) => ({
      code: custom_banner_order_prefix + num,
      name: "カスタムリンクバナー " + num,
      show: show,
    });

    // パネルの展開アニメーション（約300ms）の完了を待つ
    const waitPanelOpen = async () => {
      await nextTick();
      await new Promise((resolve) => setTimeout(resolve, 350));
    };

    // カスタムリンクバナー追加
    const addCustomBanner = () => {
      if (state.custom_banners.length >= setting.hp_link_custom_banner_max) {
        return;
      }
      state.custom_banners.push({
        key: custom_banner_key++,
        name: "",
        detail: "",
        target: "0", // 初期値は同じタブ
      });
      const num = state.custom_banners.length;
      // コンテンツ配置の末尾に追加
      state.category_items.top_order.drag_data = [
        ...state.category_items.top_order.drag_data,
        createCustomBannerOrder(num, true),
      ];
      // 追加したパネルを開く
      state.custom_banner_panels = [...state.custom_banner_panels, num - 1];
    };

    // カスタムリンクバナー削除
    const removeCustomBanner = (index) => {
      if (
        !window.confirm("カスタムリンクバナーを削除します。よろしいですか？")
      ) {
        return;
      }
      const remove_num = index + 1;
      state.custom_banners.splice(index, 1);
      // コンテンツ配置から削除し、後ろのバナー番号を詰める
      state.category_items.top_order.drag_data =
        state.category_items.top_order.drag_data
          .filter((d) => getCustomBannerNum(d.code) !== remove_num)
          .map((d) => {
            const num = getCustomBannerNum(d.code);
            if (num > remove_num) {
              return createCustomBannerOrder(num - 1, d.show);
            }
            return d;
          });
      state.custom_banner_panels = [];
    };

    const getListData = async () => {
      // サイト設定データ取得
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      const params = {
        shop_site_id: props.shop_site_id,
        data_id: data_id,
      };
      const response = await retryRequest(
        HpListDetailRepository.list_data,
        params,
        true
      );
      if (response.data) {
        // 取得したデータをstateにセット
        for (const key of Object.keys(state.category_items)) {
          const item = state.category_items[key];
          const getItem = response.data.find(
            (i) => i.category_code === item.category_code
          );
          if (!getItem) continue; // 該当データがない場合はスキップ

          item.name = getItem.name || "";
          item.detail = getItem.detail || "";
          if (item.category_code === "top_order") {
            item.drag_data =
              JSON.parse(getItem.detail) || setting.hp_link_top_content;

            // settingに存在するがdrag_dataにない項目を末尾に追加
            const existingCodes = item.drag_data.map((d) => d.code);
            setting.hp_link_top_content.forEach((defaultItem) => {
              if (!existingCodes.includes(defaultItem.code)) {
                item.drag_data.push({ ...defaultItem, show: false });
              }
            });
          }
          if (item.type === "switch") {
            item.detail = getItem.detail === "1" ? true : false;
          }
        }

        // カスタムリンクバナーをバナー番号順にセット
        state.custom_banners = response.data
          .filter((i) => i.category_code === custom_banner_code)
          .sort((a, b) => a.category_num - b.category_num)
          .map((getItem) => {
            const target = response.data.find(
              (i) =>
                i.category_code === custom_banner_target_code &&
                i.category_num === getItem.category_num
            );
            return {
              key: custom_banner_key++,
              name: getItem.name || "",
              detail: getItem.detail || "",
              target: target && target.detail === "1" ? "1" : "0",
            };
          });

        // コンテンツ配置をカスタムリンクバナーの件数に合わせる
        const top_order = state.category_items.top_order;
        top_order.drag_data = top_order.drag_data.filter((d) => {
          const num = getCustomBannerNum(d.code);
          return num === 0 || num <= state.custom_banners.length;
        });
        state.custom_banners.forEach((banner, index) => {
          const order = createCustomBannerOrder(index + 1, false);
          if (!top_order.drag_data.some((d) => d.code === order.code)) {
            top_order.drag_data.push(order);
          }
        });
      }

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");
    };

    onMounted(() => {
      getListData();
    });

    const onSubmit = async () => {
      // 入力チェック エラー状態の部品が無いか調べる
      const isValid = await ctx.refs.observer.validate();

      if (!isValid) {
        // エラー処理
        // 閉じているカスタムリンクバナーのエラーも表示するため、パネルをすべて開く
        state.custom_banner_panels = state.custom_banners.map((_, i) => i);
        await waitPanelOpen();
        const el = document.querySelectorAll(
          ".v-text-field.error--text, .v-textarea.error--text"
        );
        if (el.length > 0) {
          el[0].scrollIntoView();
          window.scrollBy(0, -80);
        }
        return;
      } else {
        // カスタムリンクバナーの画像必須チェック
        for (const [index, banner] of state.custom_banners.entries()) {
          const uploader = ctx.refs[custom_banner_ref_prefix + banner.key][0];
          if (
            !uploader.uploadImage.image_path &&
            !uploader.uploadImage.image_base64
          ) {
            state.custom_banner_panels = [index];
            await waitPanelOpen();
            uploader.$el.scrollIntoView();
            window.scrollBy(0, -80);
            alert(
              "カスタムリンクバナー " +
                (index + 1) +
                " のバナー画像を設定してください。"
            );
            return;
          }
        }

        // サイト設定保存処理
        if (!window.confirm("保存してよろしいですか？")) {
          return false;
        }

        store.dispatch("loadingIcon/showIcon"); // ローディング表示

        // カスタムリンクバナーの画像アップロード処理
        // ※画像必須のため、アップロードに失敗した場合は保存を中断する
        for (const [index, banner] of state.custom_banners.entries()) {
          const path = await ctx.refs[
            custom_banner_ref_prefix + banner.key
          ][0].saveImage();
          if (!path) {
            store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
            alert(
              "カスタムリンクバナー " +
                (index + 1) +
                " の画像のアップロードに失敗したため、保存を中断しました。"
            );
            return;
          }
          banner.detail = path; // アップロード後の画像パスをセット
        }

        for (const key of Object.keys(state.category_items)) {
          const item = state.category_items[key];
          if (item.type === "image") {
            // 画像アップロード処理
            const path = await ctx.refs[item.ref].saveImage();
            item.detail = path; // アップロード後の画像パスをセット
          } else if (item.type === "html") {
            // HTML入力処理
            item.detail = ctx.refs[item.ref].editorData;
          } else if (item.type === "order") {
            item.detail = JSON.stringify(item.drag_data);
          } else if (item.type === "switch") {
            item.detail = item.detail ? "1" : "0";
          } else {
            // 特に何もしない
          }
        }

        const save_list = Object.values(state.category_items).map((item) => {
          return {
            shop_site_id: props.shop_site_id,
            data_id: data_id,
            category_num: 0,
            category_code: item.category_code,
            name: item.name,
            detail: item.detail,
          };
        });

        // カスタムリンクバナー（category_num = バナー番号）
        for (const [index, banner] of state.custom_banners.entries()) {
          save_list.push(
            {
              shop_site_id: props.shop_site_id,
              data_id: data_id,
              category_num: index + 1,
              category_code: custom_banner_code,
              name: banner.name,
              detail: banner.detail,
            },
            {
              shop_site_id: props.shop_site_id,
              data_id: data_id,
              category_num: index + 1,
              category_code: custom_banner_target_code,
              name: "",
              detail: banner.target,
            }
          );
        }

        const params = {
          shop_site_id: props.shop_site_id,
          data_id: data_id,
          save_list: save_list,
        };

        // switchの値を元に戻す
        for (const key of Object.keys(state.category_items)) {
          const item = state.category_items[key];
          if (item.type === "switch") {
            item.detail = item.detail == "1" ? true : false;
          }
        }

        await HpListDetailRepository.save_list(params)
          .then((response) => {
            if (response.data) {
              // 保存OK
              alert("サイト設定を保存しました。");
            }
          })
          .catch((error) => {
            throw "ERROR:HpListDetailRepository.save_list (" + error + ")";
          });

        // ローディング非表示
        store.dispatch("loadingIcon/hideIcon");

        ctx.refs.observer.reset();
      }
    };

    const onHtmlClear = (type) => {
      if (
        !window.confirm("HTMLに入力された内容をクリアします。よろしいですか？")
      ) {
        return;
      }
      if (type === 1) {
        state.category_items.top_html.detail = "";
        if (refCkeditorTopHtml.value) {
          refCkeditorTopHtml.value.editorData = "";
        }
      } else if (type === 2) {
        state.category_items.footer_html.detail = "";
        if (refCkeditorFooterHtml.value) {
          refCkeditorFooterHtml.value.editorData = "";
        }
      }
    };

    // 返却オブジェクト定義
    return {
      dragOptions: {
        animation: 200,
        group: "cast",
        disabled: false,
        ghostClass: "ghost",
      },
      refSiteShopName,
      refSiteTitle,
      refDescription,
      refBookingUrl,
      refIUTopImage,
      refIULogoImage,
      refIUSiteIcon,
      refIUBgImageA,
      refIUBgImageB,
      refIUBanner1,
      refIUBanner2,
      refIUBanner3,
      refIUNoImage,
      refCkeditorTopHtml,
      refCkeditorFooterHtml,
      refGtagId,
      refGaValidCode,
      setting,
      custom_banner_ref_prefix,
      ...toRefs(state),
      onSubmit,
      onHtmlClear,
      addCustomBanner,
      removeCustomBanner,
    };
  },
});
</script>
